import {
  locationDisplay,
  sanitizeHtml,
  formatPrice,
  renterError,
  LOCATION_COPY,
  formatDateTime,
  isLongTerm,
  extrasToSend,
  isEmail,
  normalizeDigits,
  useCreateBooking,
  dailyRate,
} from "@1-now/booking-core";
import React, { useEffect, useState, ChangeEvent, useRef } from "react";
import { clearRenterSession, setRenterSession } from "utils/renterSession";
import { CheckIcon, Squares2X2Icon } from "@heroicons/react/24/outline";
import PhoneInput from "react-phone-input-2";
import { useNavigate, useLocation, useParams, Navigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import RequestPriceButton from "shared/RequestPriceButton/RequestPriceButton";
import { hasNoPrice } from "utils/carPrice";
import { fitInlineColors } from "utils/fitInlineColors";
import { Checkbox } from "@headlessui/react";
import toast from "react-hot-toast";
import { useData } from "data/data-provider";
import { getInvoice, getLongTermWeeklyQuote } from "api/Invoice/invoice";
import { globalJson } from "global/global_json";
import Input from "shared/Input/Input";
import { getBonzahProducts } from "api/bonzah/bonzah";
import { AddCustomer, uploadCustomerFiles } from "api/customer/customer";
import { CodeGate, codeGateFrom, codeRequired, verifyEmailCode } from "designs/Common/EmailCode/emailCode";
import { EmailCodeDialog } from "designs/Common/EmailCode/EmailCodeSurfaces";
import { carAddress, clearHeld, holdBooking } from "designs/Common/EmailCode/heldBooking";
import Badge from "shared/Badge/Badge";
import moment from "moment";
import { LocationListingModal } from "models/LocationModal";
import { getLocationData } from "api/locations/locations";
import DropOffBranchLocationInput from "designs/Common/DropOffBranchLocationInput";
import LocationBranchInput from "designs/Common/LocationBranchInput";
import RentalCarDatesRangeInput from "../(car-search-form)/RentalCarDatesRangeInput";
import RentalCarTimesRangeInput from "../(car-search-form)/RentalCarTimesRangeInput";
import NcModal from "../NcModal/NcModal";
import { Slide } from "react-slideshow-image";
import { pick, set } from "lodash";
import DateRangeSelection from "../(car-search-form)/dateRangeSelection";
import LongTermRentalUI from "../ListingDetailPage/listing-car-detail/LongTermRentalUI";
import { hasExpensiveCycles } from "../(car-search-form)/LongTermInvoice";
import Invoice from "../(car-search-form)/invoice";
import VehicleDetailsSection from "../VehicleDescription/VehicleDescriptionSection";
import { payLaterPoliciesState } from "designs/Common/PayLaterPoliciesPage/PayLaterPoliciesPage";
import BackRouteButton from "shared/BackRouteButton/BackRouteButton";
import { useIsDesignB } from "../CarPageB/useIsDesignB";
import CarTopB, { BackToCars } from "../CarPageB/CarTopB";
import CarTripCard from "../CarPageB/CarTripCard";
import CarTripBar from "../CarPageB/CarTripBar";
import BonzahAcknowledgement, { BONZAH_POLICY_LINKS } from "../BonzahAcknowledgement/BonzahAcknowledgement";
import { trackEvent } from "analytics/posthog";
import { trackBookingStarted, trackBookingStepError } from "analytics/bookingEvents";
import { setMetaUserData } from "analytics/metaPixel";
import { getMetaAttribution } from "analytics/metaAttribution";
import { useIsDesktop, useIsPhone } from "../BookingSteps/useIsPhone";
import { usePhoneBooking } from "../BookingSteps/usePhoneBooking";
import { useBookingFlow } from "../BookingSteps/useBookingFlow";
import PhoneBooking from "../BookingSteps/PhoneBooking";
import DesktopBooking from "../BookingSteps/DesktopBooking";
import { CarPageOverview } from "../BookingSteps/BookingOverview";

export default function CarListingCarDetailPage() {
  const navigate = useNavigate();
  const location = useLocation();
  // One per button, so a lost pay-later create is never taken for a card
  // booking, nor the other way round.
  const createBookingNow = useCreateBooking();
  const createBookingLater = useCreateBooking();
  const initialBonzahFetched = useRef(false);
  const {
    selectedCar,
    ourVehicles,
    ourVehiclesLoading,
    ourVehiclesSettled,
    ourVehiclesError,
    retryOurVehicles,
    user,
    startDate,
    startHours,
    startMinutes,
    startPeriod,
    endDate,
    endHours,
    endMinutes,
    pickupLocation,
    setInvoice,
    selectedExtras,
    setSelectedExtras,
    bonzahProducts,
    bookingdetails,
    setBookingdetails,
    setBonzahProducts,
    setSelectedBonzahProducts,
    selectedBonzahProducts,
    setSelectedBonzahAddOns,
    selectedBonzahAddOns,
    invoice,
    setSameDropoffLocation,
    dropOffLocation,
    searchedPickupLoction,
    searchedDropoffLocation,
    sameDropoffLocation,
    dropoffLocationType,
    setDropoffLocationType,
    setDropoffLocation,
    endPeriod,
    firstName,
    setFirstName,
    lastName,
    unavailable,
    setLastName,
    email,
    setEmail,
    phone,
    setPhone,
    setPickupLocation,
    setStartDate,
    setEndDate,
    startTime,
    endTime,
    ourCompany,
    is_long_term_rental,
    long_term_rental_nature,
    long_term_rental_duration,
    is_hourly_rental,
    selectedMonth,
    selectedWeeks,
    setSelectedWeeks,
    setSelectedMonth,
    companyDetails,
    ourLocation: providerLocations,
    weeklyQuote,
    setWeeklyQuote,
    acknowledgedExpensiveCycles,
    setAcknowledgedExpensiveCycles,
  } = useData();

  // Funnel step: customer viewed a vehicle listing. Counted as "Viewed
  // vehicle" (scoped by company_id) in the admin monthly-review dashboard.
  useEffect(() => {
    if (selectedCar?.id) {
      trackEvent("vehicle_listing_viewed", {
        vehicle_id: selectedCar?.id,
        vehicle_name: selectedCar?.name,
        // 1NOW-11121: the same daily rate the fleet cards show, for Meta ViewContent.
        value: dailyRate(selectedCar) ?? undefined,
        currency: ourCompany?.currency,
      });
    }
  }, [selectedCar?.id]);

  let [bonzahProductsLoading, setBonzahProductsLoading] = useState(false);
  const [isDropOffVisible, setIsDropOffVisible] = useState(false);
  const [selectedBonzahType, setSelectedBonzahType] = useState<any>([]);
  const selectedBonzahTypeRef = useRef<any>([]);
  const [bonzahAckOpen, setBonzahAckOpen] = useState(false);
  const [bonzahAcknowledged, setBonzahAcknowledged] = useState(false);
  const [pendingBonzahProduct, setPendingBonzahProduct] = useState<any>(null);
  const [pendingBonzahAddon, setPendingBonzahAddon] = useState<string | null>(null);
  // Replays which booking action ("now" → Pay & Book, "later" → Pay Later)
  // was deferred behind the Bonzah-terms acknowledgement popup, so we can
  // resume it once the renter explicitly accepts the terms (ONENOW-491).
  const [pendingBookingMode, setPendingBookingMode] = useState<
    "now" | "later" | null
  >(null);
  const bonzahProductsRef = useRef<any>(null);

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [ourLocation, setOurLocation] = useState<LocationListingModal[]>([]);
  const [isMoreThan30Days, setIsMoreThan30Days] = useState(false);
  const [isReadMore, setIsReadMore] = useState(true);
  const [selectedBonzah, setSelectedBonzah] = useState();
  const [loadingLater, setLoadingLater] = useState(false);
  const [renterDetailsConfirmed, setRenterDetailsConfirmed] = useState(false);
  const [showImgGallery, setShowImgGallery] = useState(false);
  const pendingNavigationRef = useRef(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isGridOpen, setIsGridOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [proofOfInsuranceFiles, setProofOfInsuranceFiles] = useState<{ file: File; url: string }[]>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  // 1NOW-11155 / 1NOW-11173: booking in steps, as a sheet on phones and as pages on desktop. `phoneOpenRef`
  // tells the booking calls below whether they were started from the steps (go on to step 5) or from the
  // old desktop buttons (go to /checkout).
  const isPhone = useIsPhone();
  // 1NOW-11176: Design B draws the top of the page, the trip fields and the scrolled trip bar its own way.
  const isB = useIsDesignB();
  const isDesktop = useIsDesktop();
  const flow = useBookingFlow();
  const { open: phoneOpen, setOpen: setPhoneOpen, step: phoneStep, setStep: setPhoneStep } = flow;
  const phoneOpenRef = useRef(false);
  const [madeBooking, setMadeBooking] = useState<any>(null);
  // 1NOW-10770: a returning renter's email, asked for a code before "Pay and book now" makes the booking.
  const [codeGate, setCodeGate] = useState<Pick<CodeGate, "customer" | "resendAfter" | "error"> | null>(null);
  /** The renter whose code was right, for these details: a booking that then fails is retried without another code. */
  const verifiedRenter = useRef<{ key: string; data: any } | null>(null);
  /** The renter form's email, on the page without steps (long-term): "Use a different email" puts the cursor there. */
  const emailInput = useRef<HTMLInputElement>(null);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (!firstName?.trim()) {
      newErrors.firstName = "First Name is required";
    }
    if (!lastName?.trim()) {
      newErrors.lastName = "Last Name is required";
    }
    if (!email?.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !isEmail(email.trim())
    ) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!phone?.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (normalizeDigits(phone).length < 10) {
      newErrors.phone = "Please enter a valid phone number";
    }

    setErrors(newErrors);
    const valid = Object.keys(newErrors).length === 0;
    if (valid) setMetaUserData({ email, phone, firstName, lastName });
    return valid;
  };

  const clearError = (field: string) => {
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[field];
      return updatedErrors;
    });
  };

  // 1NOW-11476 (Faiza): back from the Reserved page's "Use a different email", the trip the renter chose is kept,
  // so Details opens on it. It came back to an empty car page ("Select Dates"). Any other arrival starts empty.
  const keepTrip = useRef((location.state as any)?.differentEmail === true);

  useEffect(() => {
    if (keepTrip.current) return;
    const activeLocations = providerLocations.filter((loc) => loc.active !== false);
    if (activeLocations.length !== 1) {
      setPickupLocation(null);
      setDropoffLocation(null);
    }
    setStartDate(null);
    setEndDate(null);
    setSameDropoffLocation(true);
    setInvoice([]);
    setDropoffLocationType(true);
    setSelectedWeeks([]);
  }, []);

  useEffect(() => {
    const activeLocations = ourLocation.filter((loc) => loc.active !== false);
    // 1NOW-11476 (Faiza, QA, a company with two locations): back from "Use a different email" the car's locations
    // load again, and while the list is empty the kept pick-up was dropped and never put back. Wait for the list.
    if (keepTrip.current && activeLocations.length === 0) return;
    if (activeLocations.length === 1) {
      setPickupLocation(activeLocations[0]);
      setDropoffLocation(activeLocations[0]);
      return;
    }
    if (
      pickupLocation &&
      !activeLocations.some((loc) => loc.id === pickupLocation.id)
    ) {
      setPickupLocation(null);
    }
    if (
      dropOffLocation &&
      !activeLocations.some((loc) => loc.id === dropOffLocation.id)
    ) {
      setDropoffLocation(null);
    }
  }, [ourLocation, pickupLocation, dropOffLocation, setPickupLocation, setDropoffLocation]);

  useEffect(() => {
    selectedBonzahTypeRef.current = selectedBonzahType;
  }, [selectedBonzahType]);

  useEffect(() => {
    bonzahProductsRef.current = bonzahProducts;
  }, [bonzahProducts]);

  useEffect(() => {
    if (!startDate || !endDate) {
      setIsMoreThan30Days(false);
      return;
    }
    if (startDate && endDate) {
      const start = moment(`${moment(startDate).format("YYYY-MM-DD")} ${startTime}`, "YYYY-MM-DD HH:mm");
      const end = moment(`${moment(endDate).format("YYYY-MM-DD")} ${endTime}`, "YYYY-MM-DD HH:mm");
      const daysDifference = end.diff(start, "days", true);
      const currentBonzahType = selectedBonzahTypeRef.current;
      const currentBonzahProducts = bonzahProductsRef.current;

      if (daysDifference > 30 && (!is_long_term_rental || long_term_rental_nature === "daily")) {
        setIsMoreThan30Days(true);
        // Always clear addons when exceeding 30 days — Bonzah addons are not available
        setSelectedBonzahAddOns(new Set());
        const selectedProduct = currentBonzahProducts?.insurance_options?.find(
          (product: any) =>
            JSON.stringify(product.value) ===
            JSON.stringify(currentBonzahType),
        );
        if (selectedProduct && selectedProduct.insurance_by_bonzah === true) {
          toast("Bonzah Insurance is not available for more than 30 days", {
            id: "bonzah-30-days-warning",
            style: {
              background: "#fff3cd",
              color: "#856404",
            },
          });
          const canopyProduct = currentBonzahProducts?.insurance_options?.find(
            (product: any) => product.canopy === true,
          );
          if (canopyProduct) {
            setSelectedBonzahType(canopyProduct.value);
            setSelectedBonzahProducts(new Set([canopyProduct.value]));
          } else {
            setSelectedBonzahType([]);
            setSelectedBonzahProducts(new Set());
          }
        }
      } else {
        setIsMoreThan30Days(false);
        if (!currentBonzahType || currentBonzahType?.length === 0) {
          const canopyProduct = currentBonzahProducts?.insurance_options?.find(
            (product: any) => product.canopy === true,
          );
          if (canopyProduct) {
            setSelectedBonzahType(canopyProduct.value);
            setSelectedBonzahProducts(new Set([canopyProduct.value]));
          }
        }
      }
    }
  }, [startDate, endDate, startTime, endTime, is_long_term_rental, long_term_rental_nature]);

  useEffect(() => {
    if (keepTrip.current) return;
    const activeLocations = providerLocations.filter((loc) => loc.active !== false);
    if (activeLocations.length !== 1) {
      setPickupLocation(null);
      setDropoffLocation(null);
    }
    setStartDate(null);
    setEndDate(null);
  }, []);

  const toggleDropOffLocation = () => {
    setIsDropOffVisible((prevState) => !prevState);
  };

  const handleDropOffLocationClick = () => {
    toggleDropOffLocation();
    setDropoffLocationType(false);
    setSameDropoffLocation(false);
  };
  const handlePickupLocationClick = () => {
    toggleDropOffLocation();
    setDropoffLocationType(true);
    setSameDropoffLocation(true);
    setDropoffLocation(null);
  };

  const closeModal = () => {
    setIsOpenModal(false);
  };

  const closeGridModal = () => setIsGridOpen(false);

  const isDdropOffdifferent = dropoffLocationType === false;

  const fetchBonzahProducts = async (selectedType?: string) => {
    if (!selectedCar) {
      return;
    }
    setBonzahProductsLoading(true);
    const payload = {
      company_id: globalJson.company_id,
      selected_type: selectedType,
      fleet: selectedCar?.id,
      pickup_location: pickupLocation?.id,
    };

    const { data } = await getBonzahProducts(payload);
    if (data) {
      setBonzahProducts(data);
      const _start = startDate && startTime
        ? moment(`${moment(startDate).format("YYYY-MM-DD")} ${startTime}`, "YYYY-MM-DD HH:mm")
        : null;
      const _end = endDate && endTime
        ? moment(`${moment(endDate).format("YYYY-MM-DD")} ${endTime}`, "YYYY-MM-DD HH:mm")
        : null;
      const isOver30 = _start && _end
        ? _end.diff(_start, "days", true) > 30 && (!is_long_term_rental || long_term_rental_nature === "daily")
        : false;

      const validAddOns = isOver30
        ? new Set<any>()
        : new Set(
          Array.from(selectedBonzahAddOns).filter((addon: any) =>
            data?.addons?.some((item: any) => item.value[0] === addon),
          ),
        );
      setSelectedBonzahAddOns(validAddOns);
      if (data?.insurance_options?.length > 0) {
        if (selectedBonzahType?.length === 0) {
          setSelectedBonzahProducts(new Set([data.insurance_options[0].value]));
          setSelectedBonzahType(data.insurance_options[0].value);
        }
      }
    }
    setBonzahProductsLoading(false);
  };

  const hasCanopyOption = () => {
    return (
      Array.isArray(bonzahProducts?.insurance_options) &&
      bonzahProducts.insurance_options.some(
        (product: any) => product.canopy === true,
      )
    );
  };

  const attemptBonzahProductSelection = (product: any) => {
    const isCurrentlySelected =
      JSON.stringify(selectedBonzahType) === JSON.stringify(product?.value);
    if (
      product?.insurance_by_bonzah === true &&
      !isCurrentlySelected &&
      !bonzahAcknowledged
    ) {
      setPendingBonzahProduct(product);
      setBonzahAckOpen(true);
      return;
    }
    handleBonzahProductSelection(
      product.title.toLowerCase(),
      product?.value,
      product.canopy,
    );
  };

  const attemptAddonSelection = (addonType: string) => {
    if (selectedBonzahAddOns.has(addonType)) {
      // Deselecting an already-selected addon doesn't need acknowledgement.
      toggleAddonSelection(addonType);
      return;
    }
    if (!bonzahAcknowledged) {
      setPendingBonzahAddon(addonType);
      setBonzahAckOpen(true);
      return;
    }
    toggleAddonSelection(addonType);
  };

  const confirmBonzahAcknowledgement = () => {
    setBonzahAcknowledged(true);
    setBonzahAckOpen(false);
    if (pendingBonzahProduct) {
      handleBonzahProductSelection(
        pendingBonzahProduct.title.toLowerCase(),
        pendingBonzahProduct.value,
        pendingBonzahProduct.canopy,
      );
      setPendingBonzahProduct(null);
    }
    if (pendingBonzahAddon) {
      toggleAddonSelection(pendingBonzahAddon);
      setPendingBonzahAddon(null);
    }
    // Resume the deferred booking action. We pass `skipBonzahAck=true`
    // so the just-acknowledged state is honoured even though React
    // hasn't committed `bonzahAcknowledged=true` yet by the time this
    // re-invocation reads its closure (ONENOW-491).
    if (pendingBookingMode === "now") {
      setPendingBookingMode(null);
      handleBooking(true);
    } else if (pendingBookingMode === "later") {
      setPendingBookingMode(null);
      handleBookingLater(true);
    }
  };

  const handleBonzahProductSelection = (
    productType: string,
    value: any,
    canopy: boolean,
  ) => {
    const hasCanopy = hasCanopyOption();

    if (JSON.stringify(selectedBonzahType) === JSON.stringify(value)) {
      if (!hasCanopy) {
        setSelectedBonzahType([]);
        setSelectedBonzahProducts(new Set());
        fetchBonzahProducts();
      }
    } else {
      setSelectedBonzahType(value);
      setSelectedBonzahProducts(new Set([value]));
      fetchBonzahProducts(productType);
    }
  };

  useEffect(() => {
    if (!initialBonzahFetched.current) {
      if (!selectedCar) {
        return;
      }
      const fetchInitialBonzah = async () => {
        const { data } = await getBonzahProducts({
          company_id: globalJson.company_id,
          fleet: selectedCar?.id,
        });

        if (data) {
          setBonzahProducts(data);
          if (data.insurance_options?.length > 0) {
            setSelectedBonzahProducts(
              new Set([data.insurance_options[0].value]),
            );
            setSelectedBonzahType(data.insurance_options[0].value);
            fetchBonzahProducts(data.insurance_options[0].title.toLowerCase());
            setSelectedBonzah(data.insurance_options[0].title.toLowerCase());
          }
        }
      };
      fetchInitialBonzah();
      initialBonzahFetched.current = true;
    } else {
      if (selectedBonzahType?.length > 0) {
        fetchBonzahProducts(selectedBonzah);
      } else {
        fetchBonzahProducts();
      }
    }
  }, [startDate, endDate, selectedCar, pickupLocation]);

  const toggleAddonSelection = (addonType: string) => {
    setSelectedBonzahAddOns((prevSelected) => {
      const updatedSet = new Set(prevSelected);
      if (updatedSet.has(addonType)) {
        updatedSet.delete(addonType);
      } else {
        updatedSet.add(addonType);
      }
      return updatedSet;
    });
  };

  const fetchInvoice = async () => {
    // A car with no price can't be booked, so there is nothing to quote.
    if (hasNoPrice(selectedCar)) return;
    // Don't ship a tentative invoice request before the renter has actually
    // picked dates (ONENOW-493 / 1NOW-1079). Also bail if dates are
    // present as Date objects but happen to be `Invalid Date` (handler
    // computed garbage), so we don't ship an empty `pick_up_time` to
    // a backend that still 500s on it from non-storefront callers.
    const isValidDate = (d: Date | null | undefined) =>
      !!d && d instanceof Date && !isNaN(d.getTime());
    if (!isValidDate(startDate) || !isValidDate(endDate)) {
      return;
    }
    if (isDdropOffdifferent && dropOffLocation === null) {
      return;
    } else {
      const selectedAddons = Array.from(selectedBonzahAddOns);
      const addonsValues = selectedAddons
        .map((item) => {
          const addon = bonzahProducts.addons.find(
            (addon: any) => addon.value[0] === item,
          );
          return addon ? addon.value : [];
        })
        .flat();

      let payload: any = {
        customer: user?.id,
        fleet: selectedCar?.id,
        pick_up_time: formatDateTime(startDate, startTime),
        drop_off_time: formatDateTime(endDate, endTime),
        pick_up_location: pickupLocation?.id,
        drop_off_location:
          sameDropoffLocation === false
            ? dropOffLocation?.id
            : pickupLocation?.id,
        custom_pick_up_address: searchedPickupLoction,
        custom_drop_off_address:
          sameDropoffLocation === false
            ? searchedDropoffLocation
            : searchedPickupLoction,
        same_drop_off_address: sameDropoffLocation,
        extras: extrasToSend(selectedCar?.extras, selectedExtras),
        bonzah_insurance_options: [...selectedBonzahType, ...addonsValues],
      };

      if (
        ourCompany?.allow_long_term_rentals &&
        long_term_rental_nature !== "daily"
      ) {
        payload = {
          ...payload,
          is_long_term_rental: is_long_term_rental,
          long_term_rental_nature: long_term_rental_nature,
          long_term_rental_duration: long_term_rental_duration,
        };
      }

      if (is_hourly_rental) {
        payload = { ...payload, is_hourly_rental: true };
      }

      const data = await getInvoice(payload);
      // setLongTermInvoice(data);
      setInvoice(data);

      // 1NOW-1095: when this is a multi-cycle LTR, also pull the per-week
      // projection so the customer sees each upcoming week's projected total
      // BEFORE confirming. Reset the acknowledgement gate whenever the inputs
      // change so the renter can't keep an old "I accept escalating weeks"
      // checkbox alive after editing dates / fleet / extras.
      if (
        // The one long-term gate (isLongTerm): weekly or monthly, more than one
        // cycle, on an operator that offers it — the backend refuses a
        // one-cycle quote.
        isLongTerm(
          ourCompany,
          is_long_term_rental === true,
          long_term_rental_nature,
          long_term_rental_duration,
        )
      ) {
        const quoteResult = await getLongTermWeeklyQuote(payload);
        setWeeklyQuote(quoteResult.data ?? []);
      } else {
        setWeeklyQuote([]);
      }
      setAcknowledgedExpensiveCycles(false);
    }
  };

  useEffect(() => {
    fetchInvoice();
  }, [
    selectedExtras,
    selectedBonzahProducts,
    selectedBonzahAddOns,
    pickupLocation,
    startMinutes,
    startPeriod,
    startHours,
    endMinutes,
    endPeriod,
    endHours,
    endMinutes,
    endPeriod,
    startDate,
    endDate,
    // 1NOW-977: Hours tab writes startTime/endTime directly and "Save Dates"
    // flips is_hourly_rental without touching startDate/endDate. Without these
    // deps the invoice never re-fetched after the flag flipped, so the payload
    // sent to tentative_booking_invoice still had is_hourly_rental=false and
    // the backend priced the trip on the daily rate instead of the hourly rate.
    startTime,
    endTime,
    is_hourly_rental,
    dropOffLocation,
    sameDropoffLocation,
    searchedPickupLoction,
    searchedDropoffLocation,
  ]);

  useEffect(() => {
    setSameDropoffLocation(true);
    setSelectedExtras(new Set());
    setSelectedBonzahProducts(new Set());
    setSelectedBonzahAddOns(new Set());
    // Entering the flow starts a clean session — and drops any credential a
    // previous build persisted to localStorage (1NOW-1557).
    clearRenterSession();
    clearHeld();
  }, []);

  useEffect(() => {
    if (selectedCar) {
      callOurLocationAPI();
    }
  }, [selectedCar]);

  const handleBooking = async (skipBonzahAck = false) => {
    if (hasNoPrice(selectedCar)) return;

    if (pickupLocation === null) {
      toast.error("Please select pick-up location");
      return;
    }
    if (!sameDropoffLocation && dropOffLocation === null) {
      toast.error("Please select drop-off location");
      return;
    }
    if (startDate === null) {
      toast.error("Start date is not set");
      return;
    }

    if (endDate === null) {
      toast.error("End date is not set");
      return;
    }

    if (!validateForm()) {
      toast.error("Please fill in the details");
      return;
    }
    if (companyDetails?.show_renter_confirmation_checkbox && !renterDetailsConfirmed) {
      toast.error("Please confirm that your renter details are correct");
      return;
    }

    if (!startTime) {
      toast.error("Start time is not set");
      return;
    }

    if (!endTime) {
      toast.error("End time is not set");
      return;
    }

    if (!selectedBonzahType || selectedBonzahType.length === 0) {
      toast.error("Please select a trip insurance option");
      return;
    }

    // 1NOW-1095: defensive gate — the LongTermRentalUI button is already
    // disabled when the expensive-cycle acknowledgement is missing, but a
    // programmatic call (e.g. Bonzah ack replay path) must respect the gate
    // too, so re-check here before we hit the Booking API.
    if (
      isLongTerm(
        ourCompany,
        is_long_term_rental === true,
        long_term_rental_nature,
        long_term_rental_duration,
      ) &&
      hasExpensiveCycles(weeklyQuote) &&
      !acknowledgedExpensiveCycles
    ) {
      toast.error(
        "Please confirm you understand the per-week pricing above before continuing",
      );
      return;
    }

    const selectedInsuranceProduct = bonzahProducts?.insurance_options?.find(
      (p: any) => JSON.stringify(p.value) === JSON.stringify(selectedBonzahType),
    );
    const requiresProofOfInsurance =
      selectedInsuranceProduct &&
      selectedInsuranceProduct.upload_before_payment === true;

    // 1NOW-1232: gate on the *requirement*, not on whether files happen to
    // exist. If the selected insurance option requires proof of insurance
    // before payment and the renter hasn't uploaded a document, block the
    // proceed, surface a clear error, and keep them on the page. The backend
    // independently enforces this (source of truth) — this is the UX guard.
    if (requiresProofOfInsurance && proofOfInsuranceFiles.length === 0) {
      toast.error("Please upload proof of insurance before continuing.");
      setLoading(false);
      return;
    }

    // ONENOW-491 compliance gate: if Bonzah is on this booking the renter
    // must have explicitly accepted Bonzah's terms / privacy / eligible
    // vehicle types via the acknowledgement popup before we create the
    // booking. The manual-toggle path already gates ack at selection
    // time, but Bonzah can be auto-selected on mount and the renter never
    // goes through that path — so without this check the popup is never
    // shown for the entire auto-select flow.
    // 1NOW-1173: the gate must key off `insurance_by_bonzah`, NOT
    // `canopy !== true`. The old `canopy !== true` check fired the Bonzah
    // popup for every non-Canopy product — including Rental Cover,
    // TeqMobility and other custom (non-Bonzah) options — which is wrong.
    // The ack only applies to actual Bonzah primary products or addons.
    const requiresBonzahAck =
      (selectedInsuranceProduct &&
        selectedInsuranceProduct.insurance_by_bonzah === true) ||
      selectedBonzahAddOns.size > 0;
    if (requiresBonzahAck && !skipBonzahAck && !bonzahAcknowledged) {
      setPendingBookingMode("now");
      setBonzahAckOpen(true);
      return;
    }

    setLoading(true);
    const selectedAddons = Array.from(selectedBonzahAddOns);
    const addonsValues = selectedAddons
      .map((item) => {
        const addon = bonzahProducts.addons.find(
          (addon: any) => addon.value[0] === item,
        );
        return addon ? addon.value : [];
      })
      .flat();

    const customerPayload = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone_no: phone,
      company: globalJson.company_id,
    };

    try {
      // 1NOW-10770: `email_code` asks the server for a code to be mailed when this is a returning renter's email (no
      // token comes back then); a new renter, and an older server, answer as before.
      const known =
        verifiedRenter.current?.key === JSON.stringify(customerPayload) ? verifiedRenter.current.data : null;
      const response = known ? { data: known } : await AddCustomer({ ...customerPayload, email_code: true });
      // AddCustomer already normalizes failures to { error } with renter-safe
      // copy — a blocked identity's refusal (1NOW-10512) surfaces here.
      if (response.error) {
        toast.error(response.error);
        trackBookingStepError("review", response.error, { vehicle_id: selectedCar?.id });
        return;
      }

      if (codeRequired(response.data)) {
        setCodeGate(codeGateFrom(customerPayload, response.data));
        if (phoneOpenRef.current) steps.onCodeRequired();
        return;
      }

      if (response.data) {
        setRenterSession(response.data);

        const customerId = response.data.id;
        /* The pk goes on the booking, which is a plain FK write. The uuid is
           what names this renter to /api/customers/files/ below — that one
           takes no login, so it no longer answers to a guessable id
           (1NOW-10707). */
        const customerUid = response.data.unique_identifier;

        let payload: any = {
          customer: customerId,
          fleet: selectedCar?.id,
          pick_up_time: formatDateTime(startDate, startTime),
          drop_off_time: formatDateTime(endDate, endTime),
          pick_up_location: pickupLocation?.id,
          drop_off_location:
            sameDropoffLocation === false
              ? dropOffLocation?.id
              : pickupLocation?.id,
          custom_pick_up_address: searchedPickupLoction,
          custom_drop_off_address:
            sameDropoffLocation === false
              ? searchedDropoffLocation
              : searchedPickupLoction,
          same_drop_off: sameDropoffLocation,
          extras: extrasToSend(selectedCar?.extras, selectedExtras),
          bonzah_insurance_options: [...selectedBonzahType, ...addonsValues],
          // 1NOW-11122: fbp/fbc/fbclid for the backend's Meta server event.
          meta_attribution: getMetaAttribution(),
        };

        if (
          ourCompany?.allow_long_term_rentals &&
          long_term_rental_nature !== "daily"
        ) {
          payload = {
            ...payload,
            is_long_term_rental: is_long_term_rental,
            long_term_rental_nature: long_term_rental_nature,
            long_term_rental_duration: long_term_rental_duration,
          };
        }

        if (is_hourly_rental) {
          payload = { ...payload, is_hourly_rental: true };
        }
        // useCreateBooking: after a create whose answer was lost, the booking
        // it may have made is found before another is made.
        const made = await createBookingNow(payload);
        // 1NOW-9077 — see the matching comment in ListingCarDetailPage: storing
        // the response before checking it left `{ error: "..." }` in
        // bookingdetails and produced a blank checkout page later.
        if (made.error) {
          toast.error(made.error);
          trackBookingStepError("review", made.error, { vehicle_id: selectedCar?.id });
          return;
        }
        const bookingResponse = made.booking;
        setBookingdetails(bookingResponse);
        if (requiresProofOfInsurance && proofOfInsuranceFiles.length > 0 && bookingResponse?.id) {
          for (const { file } of proofOfInsuranceFiles) {
            await uploadCustomerFiles(String(customerUid), [file], "insurance");
          }
          setProofOfInsuranceFiles([]);
        }
        // 1NOW-10770: the code box gives way to Pay only together with the booking, so Pay never shows the consent
        // line without that booking's agreement (the uploads above take a moment).
        setCodeGate(null);
        if (phoneOpenRef.current) steps.onBooked(bookingResponse);
        else navigate("/checkout");
        return true;
      }
    } catch (err: any) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleBookingLater = async (skipBonzahAck = false) => {
    if (hasNoPrice(selectedCar)) return;

    if (pickupLocation === null) {
      toast.error("Please select pick-up location");
      return;
    }
    if (!sameDropoffLocation && dropOffLocation === null) {
      toast.error("Please select drop-off location");
      return;
    }
    if (startDate === null) {
      toast.error("Start date is not set");
      return;
    }

    if (endDate === null) {
      toast.error("End date is not set");
      return;
    }

    if (!validateForm()) {
      toast.error("Please fill in the details");
      return;
    }
    if (companyDetails?.show_renter_confirmation_checkbox && !renterDetailsConfirmed) {
      toast.error("Please confirm that your renter details are correct");
      return;
    }
    if (!startTime) {
      toast.error("Start time is not set");
      return;
    }

    if (!endTime) {
      toast.error("End time is not set");
      return;
    }

    if (!selectedBonzahType || selectedBonzahType.length === 0) {
      toast.error("Please select a trip insurance option");
      return;
    }

    // 1NOW-1095 defensive gate, mirrors handleBooking.
    if (
      isLongTerm(
        ourCompany,
        is_long_term_rental === true,
        long_term_rental_nature,
        long_term_rental_duration,
      ) &&
      hasExpensiveCycles(weeklyQuote) &&
      !acknowledgedExpensiveCycles
    ) {
      toast.error(
        "Please confirm you understand the per-week pricing above before continuing",
      );
      return;
    }

    const selectedInsuranceProductLater = bonzahProducts?.insurance_options?.find(
      (p: any) => JSON.stringify(p.value) === JSON.stringify(selectedBonzahType),
    );
    const requiresProofOfInsuranceLater =
      selectedInsuranceProductLater &&
      selectedInsuranceProductLater.upload_before_payment === true;

    // 1NOW-1232: same proof-of-insurance gate as the Pay path — block the
    // Pay Later proceed identically until a document is uploaded.
    if (requiresProofOfInsuranceLater && proofOfInsuranceFiles.length === 0) {
      toast.error("Please upload proof of insurance before continuing.");
      setLoadingLater(false);
      return;
    }

    // Same compliance gate as handleBooking. See the long comment there
    // for rationale (ONENOW-491 / 1NOW-1173).
    const requiresBonzahAckLater =
      (selectedInsuranceProductLater &&
        selectedInsuranceProductLater.insurance_by_bonzah === true) ||
      selectedBonzahAddOns.size > 0;
    if (requiresBonzahAckLater && !skipBonzahAck && !bonzahAcknowledged) {
      setPendingBookingMode("later");
      setBonzahAckOpen(true);
      return;
    }

    setLoadingLater(true);

    const selectedAddons = Array.from(selectedBonzahAddOns);
    const addonsValues: string[] = selectedAddons
      .map((item) => {
        const addon = bonzahProducts?.addons?.find(
          (addon: any) => addon.value[0] === item,
        );
        return addon ? addon.value : [];
      })
      .flat();

    const customerPayload = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone_no: phone,
      company: globalJson.company_id,
    };

    // 1NOW-10770: a pay-now code question left open is not this reservation's: the Pay step shows the reservation.
    setCodeGate(null);
    try {
      const response = await AddCustomer({ ...customerPayload, email_code: true });
      if (response.error) {
        toast.error(response.error);
        trackBookingStepError("review", response.error, { vehicle_id: selectedCar?.id });
        return;
      }
      if (!startDate || !endDate) {
        toast.error("No start date or end date");
        return;
      }

      if (response.data) {
        // 1NOW-10770: a returning renter has no token yet, only a code in their inbox: nothing to store.
        const needsCode = codeRequired(response.data);
        if (!needsCode) setRenterSession(response.data);

        const customerId = response.data.id;
        /* The pk goes on the booking, which is a plain FK write. The uuid is
           what names this renter to /api/customers/files/ below — that one
           takes no login, so it no longer answers to a guessable id
           (1NOW-10707). */
        const customerUid = response.data.unique_identifier;

        let payload: any = {
          customer: customerId,
          fleet: selectedCar?.id,
          pick_up_time: formatDateTime(startDate, startTime),
          drop_off_time: formatDateTime(endDate, endTime),
          pick_up_location: pickupLocation?.id,
          drop_off_location:
            sameDropoffLocation === false
              ? dropOffLocation?.id
              : pickupLocation?.id,
          custom_pick_up_address: searchedPickupLoction,
          custom_drop_off_address:
            sameDropoffLocation === false
              ? searchedDropoffLocation
              : searchedPickupLoction,
          same_drop_off: sameDropoffLocation,
          extras: extrasToSend(selectedCar?.extras, selectedExtras),
          bonzah_insurance_options: [...selectedBonzahType, ...addonsValues],
          // 1NOW-11122: fbp/fbc/fbclid for the backend's Meta server event.
          meta_attribution: getMetaAttribution(),
          pay_later: true,
        };

        if (
          ourCompany?.allow_long_term_rentals &&
          long_term_rental_nature !== "daily"
        ) {
          payload = {
            ...payload,
            is_long_term_rental: is_long_term_rental,
            long_term_rental_nature: long_term_rental_nature,
            long_term_rental_duration: long_term_rental_duration,
          };
        }

        if (is_hourly_rental) {
          payload = { ...payload, is_hourly_rental: true };
        }

        // 1NOW-10770: the reservation is not made before the code is right. What it will be made from is held for
        // the Reserved page, which asks for the code and makes it (ReservedCodeGate).
        if (needsCode) {
          const { resendAfter, error } = codeGateFrom(customerPayload, response.data);
          holdBooking(
            {
              customer: customerPayload,
              payload,
              car: { id: selectedCar?.id, name: selectedCar?.name, photo: steps.props.photo, range: steps.props.trip.range },
              proofRequired: Boolean(requiresProofOfInsuranceLater),
              returnTo: carAddress(location),
              resendAt: resendAfter ? Date.now() + resendAfter * 1000 : undefined,
              error,
            },
            proofOfInsuranceFiles,
          );
          navigate("/reserved");
          return;
        }

        const madeLater = await createBookingLater(payload);
        if (madeLater.error) {
          toast.error(madeLater.error);
          setLoadingLater(false);
          return;
        }
        const bookingdetail = madeLater.booking;
        if (requiresProofOfInsuranceLater && proofOfInsuranceFiles.length > 0 && bookingdetail?.id) {
          for (const { file } of proofOfInsuranceFiles) {
            await uploadCustomerFiles(String(customerUid), [file], "insurance");
          }
        }
        setBookingdetails(bookingdetail);
        // Pay later never opens the checkout page, where "started booking" is counted for a
        // card booking: count it here, once the booking exists (1NOW-11119).
        trackBookingStarted(bookingdetail, selectedCar, ourCompany?.currency);
        // 1NOW-11205: from the steps the review's "Pay later" makes the reservation here, and the
        // renter lands on Pay with it (its filled-in agreement); Pay's "Reserve" goes on to
        // the success page, which counts down to its booking page (1NOW-11198).
        if (phoneOpenRef.current) {
          setProofOfInsuranceFiles([]);
          steps.onBooked(bookingdetail);
          return;
        }
        // The policies page, with the booking's filled-in agreement.
        const policies = await payLaterPoliciesState(bookingdetail.unique_identifier);
        setProofOfInsuranceFiles([]);
        navigate("/pay-later-policies", { state: policies });
      }
    } catch (err: any) {
      toast.error(renterError(err, "booking"));
      setLoadingLater(false);
    } finally {
      setLoadingLater(false);
    }
  };

  const callOurLocationAPI = async () => {
    if (selectedCar) {
      try {
        const data = await getLocationData(selectedCar?.id);
        if (Array.isArray(data)) {
          setOurLocation(data as LocationListingModal[]);
        } else {
          throw new Error("Unable to fetch location data");
        }
      } catch (error: any) {
        toast.error(renterError(error, "locations"));
        console.error("Location API error:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleOpenModalImageGallery = (index: number) => {
    if (selectedCar?.fleet_photos?.length === 0) {
      toast("No Images available for this fleet", {
        style: {
          background: "#fff3cd",
          color: "#856404",
        },
      });
    } else {
      setCurrentIndex(index);
      setIsOpenModal(true);
    }
  };



  const renderUserSection = () => {
    // Design B draws the trip fields as a card of tiles at the top of the page (tripCard); the steps replace the rest.
    if (isB && stepped) return null;
    return (
      <div className="border-secondary-100 flex flex-col sm:rounded-md border-b sm:border-t sm:border-l sm:border-r sm:space-y-8 pb-10 px-0 sm:p-4 xl:p-8 !space-y-6">
        {" "}
        {!isB && (<>
        <h2 id="trip-details" className="text-xl text-text-color font-bold">Trip Details</h2>
        <form className="flex flex-col border-secondary-100 rounded-md ">
          <div className={`${isDdropOffdifferent ? " " : "w-full my-2"}`}>
            <LocationBranchInput
              ourLocation={ourLocation}
              /* One field covers both ends until a separate drop-off is
                 opened, so it's named for both, as on the home search bar. */
              placeHolder={
                isDropOffVisible
                  ? LOCATION_COPY.pickUp.label
                  : LOCATION_COPY.same.label
              }
              className="w-full rounded-md border border-secondary-100 text-text-color placeholder:text-text-color"
              sameDropOffLocation={dropoffLocationType === false}
              searchBar={false}
            />
          </div>
          {isDropOffVisible && (
            <div className="my-2">
              <DropOffBranchLocationInput
                ourLocation={ourLocation}
                placeHolder={LOCATION_COPY.dropOff.label}
                className="w-full border-secondary-100 rounded-md border"
                divHideVerticalLineClass="-inset-x-0.5"
                searchBar={false}
              />

              <p
                className="text-xs text-text-color cursor-pointer mt-2 font-semibold"
                onClick={handlePickupLocationClick}
              >
                - Same Dropoff Location
              </p>
            </div>
          )}
          {/* If drop-off location is not visible, show the toggle text */}
          {!isDropOffVisible &&
            ourLocation.some(
              (loc) =>
                loc.location_type === "drop_off" || loc.location_type === "both"
            ) && (
              <p
                className="text-xs text-text-color cursor-pointer mb-2 font-semibold"
                onClick={handleDropOffLocationClick}
              >
                + Different Dropoff Location
              </p>
            )}

          {(pickupLocation || phoneSteps) && (
            // Phones show every trip field from the start; one that needs an earlier answer is locked until then.
            // `contents` on the rest, so the wrapper adds no box and nothing moves.
            <div
              className={pickupLocation || !phoneSteps ? "contents" : "opacity-60 [&>*]:pointer-events-none"}
              onClick={pickupLocation ? undefined : () => toast.error("Please select pick-up location")}
            >
              {ourCompany?.allow_long_term_rentals ||
              ourCompany?.allow_hourly_rentals ? (
                <DateRangeSelection
                  isMiddle={true}
                  className="w-full rounded-md my-2 border border-secondary-100"
                  selectedCar={selectedCar}
                  onSaveDates={fetchInvoice}
                />
              ) : (
                <RentalCarDatesRangeInput
                  isMiddle={true}
                  className="w-full rounded-md my-2 border border-secondary-100"
                  selectedCar={selectedCar}
                  searchBar={false}
                  minDays={selectedCar?.min_trip_duration}
                  maxDays={selectedCar?.max_trip_duration}
                />
              )}
            </div>
          )}

          {((startDate && endDate) || phoneSteps) && (
            <div
              className={(startDate && endDate) || !phoneSteps ? "contents" : "opacity-60 [&>*]:pointer-events-none"}
              onClick={startDate && endDate ? undefined : () => toast.error("Please pick your dates first")}
            >
              <RentalCarTimesRangeInput
                dropOffLocationType={dropoffLocationType}
                className="w-full rounded-md border my-2 border-secondary-100"
                searchBar={false}
              />
            </div>
          )}
        </form>
        </>)}
        {!stepped && (<>
        <h2 className="text-xl text-text-color  font-bold">Renter Details</h2>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <div className="border border-secondary-100 p-2 rounded-md">
              <span className="my-2 text-sm text-text-color">First Name</span>
              <Input
                placeholder=""
                value={firstName}
                className="border-none !p-0 focus:outline-none focus:ring-0"
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setFirstName(e.target.value);
                  setRenterDetailsConfirmed(false);
                  if (e.target.value) clearError("firstName");
                }}
              />
            </div>
            {errors.firstName && (
              <span className="text-red-500 text-xs font-semibold">
                {errors.firstName}
              </span>
            )}
          </div>
          <div>
            <div className="border border-secondary-100 p-2 rounded-md">
              <span className="my-2 text-sm text-text-color">Last Name</span>
              <Input
                placeholder=""
                value={lastName}
                className="border-none !p-0 focus:outline-none focus:ring-0"
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setLastName(e.target.value);
                  setRenterDetailsConfirmed(false);
                  if (e.target.value) clearError("lastName");
                }}
              />
            </div>
            {errors.lastName && (
              <span className="text-red-500 text-xs font-semibold">
                {errors.lastName}
              </span>
            )}
          </div>
          <div>
            <div className="border border-secondary-100 p-2 rounded-md">
              <span className="my-2 text-sm text-text-color">Email</span>
              <Input
                ref={emailInput}
                placeholder=""
                type="email"
                className="border-none !p-0 focus:outline-none focus:ring-0"
                value={email}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setEmail(e.target.value);
                  if (
                    isEmail(e.target.value)
                  ) {
                    clearError("email");
                  }
                }}
              />
            </div>
            {errors.email && (
              <span className="text-red-500 text-xs font-semibold">
                {errors.email}
              </span>
            )}
          </div>
          <div>
            <div className="border border-secondary-100 p-2 rounded-md">
              <span className="my-2 text-sm text-text-color">Phone</span>
              <PhoneInput
                country={"us"}
                value={phone}
                onChange={(phone) => {
                  setPhone(phone);
                  setRenterDetailsConfirmed(false);
                  if (normalizeDigits(phone).length >= 10) clearError("phone");
                }}
                inputProps={{
                  name: "phone",
                  required: true,
                  autoFocus: false,
                }}
                inputStyle={{
                  border: "none",
                  width: "100%",
                  minHeight: "44px",
                  boxShadow: "none",
                  background: "transparent",
                }}
                buttonStyle={{
                  background: "transparent",
                  border: "none",
                }}
              />
            </div>
            {errors.phone && (
              <span className="text-red-500 text-xs font-semibold ">
                {errors.phone}
              </span>
            )}
          </div>
        </div>

        {companyDetails?.show_renter_confirmation_checkbox && (
          <div className="flex gap-2 mt-4  items-center">
            <Checkbox
              checked={renterDetailsConfirmed}
              onChange={(checked) => {
                if (!validateForm()) {
                  toast.error("Please fill in your renter details above before confirming");
                  return;
                }
                setRenterDetailsConfirmed(checked);
              }}
              className={`group size-7 rounded-md p-1 ring-1 ring-primary-brand data-[checked]:bg-primary-brand data-[checked]:bg-opacity-20 ring-inset mr-4 flex-shrink-0 ${
                (!firstName || !lastName || !email || normalizeDigits(phone).length < 10)
                  ? "opacity-60"
                  : ""
              }`}
            >
              <CheckIcon className={`size-5 stroke-primary-brand ${renterDetailsConfirmed ? 'visible' : 'invisible'}`} />
            </Checkbox>
            {companyDetails?.renter_confirmation_checkbox_text ? (
              <span
                className="text-text-color text-sm policy-checkbox-copy"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(
                    companyDetails.renter_confirmation_checkbox_text.replace(
                      /\{\{\s*company\s*name\s*\}\}/gi,
                      companyDetails?.company_name ?? ""
                    )
                  ),
                }}
              />
            ) : (
              <span className="text-text-color text-sm">
                I confirm that my renter details are correct and I agree to receive communication from {companyDetails?.company_name} about my rental booking, service updates, and related offers.
              </span>
            )}
          </div>
        )}
        </>)}
      </div>
    );
  };

  const handleExtraChange = (extraId: any, checked: any) => {
    setSelectedExtras((prevSelectedExtras) => {
      const updatedExtras = new Set(prevSelectedExtras);
      if (checked) {
        updatedExtras.add(extraId);
      } else {
        updatedExtras.delete(extraId);
      }
      return updatedExtras;
    });
  };

  const renderSidebarPrice = () => {
    // No base price: the car can't be booked. Ask for a price instead (this
    // also leaves out the long-term UI and Pay & Book / Pay Later).
    if (hasNoPrice(selectedCar)) {
      return (
        <div className="listingSectionSidebar__wrap shadow-xl mt-4 lg:mt-0 p-6 lg:p-12 lg:max-w-xl  ">
          <h2 className="text-xl font-medium text-text-color">
            Price on request
          </h2>
          <p className="mt-2 mb-6 text-sm text-text-color">
            This car doesn't have a price yet. Request one and we'll add it.
          </p>
          <RequestPriceButton
            car={selectedCar!}
            className="nc-Button relative h-auto inline-flex items-center justify-center rounded-md px-4 py-3 sm:px-6 text-sm sm:text-base font-medium transition-colors w-full bg-primary-6000 hover:bg-primary-700 text-on-primary"
          />
        </div>
      );
    }
    // if (!pickupLocation) return null;
    if (
      ourCompany?.allow_long_term_rentals &&
      startDate &&
      endDate &&
      long_term_rental_nature !== "daily" &&
      long_term_rental_duration > 1
    ) {
      return (
        <LongTermRentalUI
          handleBooking={handleBooking}
          loading={loading}
          loadingLater={loadingLater}
          handleBookingLater={handleBookingLater}
          renterDetailsConfirmed={renterDetailsConfirmed}
        />
      );
    }
    return (
      <div className="listingSectionSidebar__wrap shadow-xl mt-4 lg:mt-0 p-6 lg:p-12 lg:max-w-xl  ">
        {pickupLocation && (
          <>
            {" "}
            <h2 className=" text-2xl sm:text-3xl lg:text-3xl font-bold text-text-color ">
              Booking Details
            </h2>
            <div className="mt-8 flex">
              <div className="flex-shrink-0 flex flex-col items-center py-2">
                <span className="block w-6 h-6 rounded-full border border-secondary-100"></span>
                <span className="block flex-grow border-l border-secondary-100 border-dashed my-1"></span>
                <span className="block w-6 h-6 rounded-full border border-secondary-100"></span>
              </div>
              <div className="ml-4 space-y-14 text-sm">
                <div className="flex flex-col space-y-2">
                  <span className=" text-text-color ">Pick up</span>
                  <span className="text-text-color font-semibold">
                    {" "}
                    {locationDisplay(pickupLocation, ourCompany?.company_name)}
                  </span>
                  {startDate && (
                    <span className=" font-semibold text-text-color !mt-0">
                      {moment(startDate).format("ddd, D MMM YYYY")}{" "}
                      {ourCompany?.default_time_format === "24_hour"
                        ? moment(startDate).format("H:mm")
                        : moment(startDate).format("h:mm A")}
                    </span>
                  )}
                </div>
                <div className="flex flex-col space-y-2">
                  <span className=" text-text-color ">Drop Off</span>
                  <span className="text-text-color font-semibold">
                    {dropoffLocationType === false && dropOffLocation?.name
                      ? locationDisplay(dropOffLocation, ourCompany?.company_name)
                      : locationDisplay(pickupLocation, ourCompany?.company_name)}
                  </span>
                  {endDate && (
                    <span className=" font-semibold text-text-color !mt-0">
                      {moment(endDate).format("ddd, D MMM YYYY")}{" "}
                      {ourCompany?.default_time_format === "24_hour"
                        ? moment(endDate).format("H:mm")
                        : moment(endDate).format("h:mm A")}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        <div className="w-full max-w-lg  mx-auto ">
          <h2 className="text-xl font-medium text-text-color">Rental Bill</h2>
          <p className="mt-2 text-sm text-text-color">
            Prices may change depending on the length of the rental and the
            price of your rental car.
          </p>

          {pickupLocation !== null && invoice?.car_total !== undefined && (
            <Invoice invoice={invoice} carName={selectedCar?.name} />
          )}
        </div>

        <ButtonPrimary
          className="block rounded-3xl"
          disabled={loading}
          onClick={() => {
            handleBooking();
          }}
        >
          {loading ? (
            <div className="flex justify-center items-center col-span-full">
              <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-secondary-100"></div>
            </div>
          ) : (
            "Pay & Book"
          )}
        </ButtonPrimary>
        {selectedCar?.pay_later && (
          <ButtonPrimary
            className="block rounded-lg mt-4"
            disabled={loadingLater}
            onClick={() => {
              handleBookingLater();
            }}
          >
            {loadingLater ? (
              <div className="flex justify-center items-center col-span-full">
                <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
              </div>
            ) : (
              "Pay Later"
            )}
          </ButtonPrimary>
        )}
      </div>
    );
  };

  const renderDescriptionWithLink = (description: string) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = description.split(urlRegex);

    return parts.map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
          >
            {part}
          </a>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  useEffect(() => {
    if (selectedCar?.extras) {
      const requiredExtras = selectedCar.extras
        .filter((extra: any) => extra.is_required)
        .map((extra: any) => extra.id);
      setSelectedExtras((prev) => {
        const updated = new Set(prev);
        requiredExtras.forEach((id) => updated.add(id));
        return updated;
      });
    }
  }, [selectedCar]);

  const renderExtrasSection = () => {
    return (
      <div className="listingSection__wrap !mb-10">
        <h2 className="text-2xl font-bold text-text-color ">Trip Extras</h2>
        {!bonzahProductsLoading &&
          !is_hourly_rental &&
          bonzahProducts?.addons?.map((addon: any) => (
            <div
              key={addon.title}
              className="flex flex-col justify-between items-start border border-secondary-100 rounded-md p-4  max-w-full"
            >
              <div className="flex items-start">
                <Checkbox
                  checked={selectedBonzahAddOns.has(addon.value[0])}
                  onChange={() => attemptAddonSelection(addon.value[0])}
                  className="group size-7 rounded-md p-1 ring-1 ring-primary-brand data-[checked]:bg-primary-brand data-[checked]:bg-opacity-20 ring-inset  mr-4"
                >
                  <CheckIcon
                    className={`size-5 stroke-primary-brand ${selectedBonzahAddOns.has(addon.value[0])
                      ? "visible"
                      : "invisible"
                      }`}
                  />
                </Checkbox>

                <div>
                  <div className="flex items-center mb-2">
                    <h2 className="text-lg md:text-xl font-bold text-text-color ">
                      {addon.title}
                    </h2>
                    {addon?.pdf && (
                      <button
                        className="ml-3 inline-flex items-center gap-1 rounded-md border border-secondary-100 px-2.5 py-1 text-xs font-medium text-text-color hover:bg-secondary-50"
                        onClick={() => window.open(addon.pdf, "_blank")}
                        type="button"
                        tabIndex={-1}
                      >
                        View Coverage
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                          />
                        </svg>
                      </button>
                    )}
                  </div>

                  {addon?.options &&
                    Object.entries(addon.options).map(([key, values]) => (
                      <div key={key} className="mt-2">
                        <ul className="list-disc pl-5 text-sm text-text-color space-y-1">
                          {(Array.isArray(values) ? values : [values]).map(
                            (detail: any, idx: number) => (
                              <li
                                key={idx}
                                style={{ wordBreak: "break-word" }}
                              >
                                {detail}
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    ))}

                  <p className="mt-2 text-xs text-text-color opacity-80">
                    Please review Bonzah&apos;s{" "}
                    {BONZAH_POLICY_LINKS.map((link, idx) => (
                      <React.Fragment key={link.href}>
                        {idx > 0 &&
                          (idx === BONZAH_POLICY_LINKS.length - 1
                            ? ", and "
                            : ", ")}
                        <a
                          href={link.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary-brand underline hover:no-underline"
                        >
                          {link.short.toLowerCase()}
                        </a>
                      </React.Fragment>
                    ))}{" "}
                    before selecting.
                  </p>
                </div>
              </div>
              <div className="mt-4 md:mt-0 w-full">
                <p className="lg:text-2xl text-lg font-bold text-text-color flex justify-end items-center">
                  ${formatPrice(addon?.price)}
                  <span className="text-text-color lg:text-lg">/day</span>
                </p>
              </div>
            </div>
          ))}
        {selectedCar?.extras.map((extra) => (
          <div
            key={extra.id}
            className="w-full rounded-md border border-secondary-100 flex flex-wrap justify-between items-center p-5"
          >
            <div className="flex justify-start flex-1 min-w-0">
              <Checkbox
                checked={selectedExtras?.has(extra.id)}
                onChange={(checked) => {
                  if (!extra.is_required) {
                    handleExtraChange(extra.id, checked);
                  }
                }}
                className="group size-7 rounded-md  p-1 ring-1 ring-primary-brand ring-inset data-[checked]:bg-primary-brand data-[checked]:bg-opacity-20  mr-4"
                disabled={extra.is_required}
              >
                <CheckIcon
                  className={`size-5 stroke-primary-brand ${selectedExtras.has(extra.id) ? "visible" : "invisible"
                    }`}
                />
              </Checkbox>
              <div className="min-w-0">
                <div className="text-text-color lg:text-lg sm:text-l font-bold flex space-x-2 flex-wrap break-words">
                  <span className="truncate block max-w-xs">{extra.name}</span>
                </div>
                <div className="text-text-color lg:text-lg sm:text-md font-medium ">
                  {renderDescriptionWithLink(extra.description)}
                </div>
              </div>
            </div>

            <div className="mt-4 md:mt-0 flex-shrink-0 flex flex-col items-end">
              <div className="mb-2 flex space-x-2">
                {extra.is_required && <Badge color="blue" name="Required" />}
                {extra.is_recommended === true && (
                  <Badge color="blue" name="Recommended" />
                )}
              </div>
              <p className="lg:text-2xl text-lg font-bold text-text-color flex justify-end items-center whitespace-nowrap">
                ${formatPrice(extra?.amount)}
                <span className="text-text-color lg:text-lg">
                  {" "}
                  /{extra?.nature === "per_day" ? "day" : "trip"}
                </span>
              </p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderBonzahSection = () => {
    // Hide Bonzah / TeqMobility insurance UI for hourly bookings (1NOW-977)
    if (is_hourly_rental) return null;
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl text-text-color  font-bold">Trip Insurance</h2>
        {bonzahProducts?.insurance_options
          // 1NOW-1599: Bonzah is offered regardless of trip length — >30-day
          // coverage is purchased as multiple ≤30-day split policies on the
          // backend (1NOW-681), matching the FMS create flow.
          .map((product: any, index: any) => (
            <div
              key={product.title}
              className="flex flex-col justify-between items-start border border-secondary-100 rounded-md p-4  max-w-full"
              style={{ wordBreak: "break-word" }}
            >
              <div className="flex items-start w-full">
                <Checkbox
                  checked={
                    JSON.stringify(selectedBonzahType) ===
                    JSON.stringify(product?.value)
                  }
                  onChange={() => attemptBonzahProductSelection(product)}
                  className="group size-7 rounded-md p-1 ring-1 ring-primary-brand ring-inset data-[checked]:bg-primary-brand data-[checked]:bg-opacity-20  mr-4"
                >
                  <CheckIcon
                    className={`size-5 stroke-primary-brand ${JSON.stringify(selectedBonzahType) ===
                      JSON.stringify(product?.value)
                      ? "visible"
                      : "invisible"
                      }`}
                  />
                </Checkbox>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center mb-2">
                    <h2 className="text-lg md:text-xl font-bold text-text-color">
                      {product.title}
                    </h2>
                    {product?.pdf !== "" && (
                      <button
                        className="ml-3 inline-flex items-center gap-1 rounded-md border border-secondary-100 px-2.5 py-1 text-xs font-medium text-text-color hover:bg-secondary-50"
                        onClick={() => window.open(product.pdf, "_blank")}
                        type="button"
                        tabIndex={-1}
                      >
                        View Coverage
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                          />
                        </svg>
                      </button>
                    )}
                  </div>

                  {product?.options &&
                    Object.entries(product.options).map(([key, values]) => (
                      <div key={key} className="mt-2">
                        {!product.canopy && product.insurance_by_bonzah && (
                          <h3 className="font-semibold text-text-color uppercase truncate">
                            {key}
                          </h3>
                        )}

                        {product.insurance_by_bonzah ? (
                          <ul className="list-disc pl-5 text-sm text-text-color space-y-1 break-words">
                            {(Array.isArray(values) ? values : [values]).map(
                              (detail: any, index: number) => (
                                <li
                                  key={index}
                                  style={{ wordBreak: "break-word" }}
                                >
                                  {detail}
                                </li>
                              ),
                            )}
                          </ul>
                        ) : (
                          <p className="lg:text-lg text-md text-text-color break-words">
                            {(Array.isArray(values) ? values : [values]).map(
                              (detail, index) => {
                                // If detail is HTML from Quill editor, render as HTML but make links clickable
                                if (
                                  typeof detail === "string" &&
                                  detail.trim().startsWith("<")
                                ) {
                                  // Replace URLs in HTML with anchor tags if not already wrapped
                                  const urlRegex = /(https?:\/\/[^\s<>"']+)/g;
                                  let html = detail.replace(urlRegex, (url) => {
                                    // If already inside an anchor tag, skip
                                    if (detail.includes(`<a href="${url}`))
                                      return url;
                                    return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-500 hover:underline">${url}</a>`;
                                  });
                                  return (
                                    <span
                                      key={index}
                                      className={
                                        product.canopy
                                          ? "text-red-500 font-semibold"
                                          : ""
                                      }
                                      style={{ wordBreak: "break-word" }}
                                      dangerouslySetInnerHTML={{ __html: fitInlineColors(sanitizeHtml(html), companyDetails?.bg_color) }}
                                    />
                                  );
                                }
                                // If detail contains a URL, make it clickable
                                const urlRegex = /(https?:\/\/[^\s]+)/g;
                                if (
                                  typeof detail === "string" &&
                                  urlRegex.test(detail)
                                ) {
                                  const parts = detail.split(urlRegex);
                                  return (
                                    <span
                                      key={index}
                                      className={
                                        product.canopy
                                          ? "text-red-500 font-semibold"
                                          : ""
                                      }
                                      style={{ wordBreak: "break-word" }}
                                    >
                                      {parts.map((part, i) =>
                                        urlRegex.test(part) ? (
                                          <a
                                            key={i}
                                            href={part}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-500 hover:underline"
                                            style={{ wordBreak: "break-word" }}
                                          >
                                            {part}
                                          </a>
                                        ) : (
                                          <React.Fragment key={i}>
                                            {part}
                                          </React.Fragment>
                                        ),
                                      )}
                                      <br />
                                    </span>
                                  );
                                }
                                // Otherwise, render as plain text
                                return (
                                  <span
                                    key={index}
                                    className={
                                      product.canopy
                                        ? "text-red-500 font-semibold"
                                        : ""
                                    }
                                    style={{ wordBreak: "break-word" }}
                                  >
                                    {detail}
                                    <br />
                                  </span>
                                );
                              },
                            )}
                          </p>
                        )}
                      </div>
                    ))}

                  {product?.insurance_by_bonzah === true && (
                    <p className="mt-3 text-xs text-text-color opacity-80">
                      Please review Bonzah&apos;s{" "}
                      {BONZAH_POLICY_LINKS.map((link, idx) => (
                        <React.Fragment key={link.href}>
                          {idx > 0 &&
                            (idx === BONZAH_POLICY_LINKS.length - 1
                              ? ", and "
                              : ", ")}
                          <a
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary-brand underline hover:no-underline"
                          >
                            {link.short.toLowerCase()}
                          </a>
                        </React.Fragment>
                      ))}{" "}
                      before selecting.
                    </p>
                  )}
                </div>
              </div>

              <div className="mt-4 md:mt-0 w-full flex justify-end items-center">
                <p className="lg:text-2xl text-lg font-bold text-text-color">
                  ${formatPrice(product.price)}
                  <span className="text-text-color lg:text-lg">
                    /
                    {product.nature === "per_trip"
                      ? "trip"
                      : product.nature === "per_day"
                        ? "day"
                        : "24 hours"}
                  </span>
                </p>
              </div>
              {product.upload_before_payment === true &&
                JSON.stringify(selectedBonzahType) ===
                JSON.stringify(product?.value) && (
                  <div className="mt-4 w-full">
                    {proofOfInsuranceFiles.length > 0 && (
                      <div className="mb-3 flex flex-col gap-2">
                        {proofOfInsuranceFiles.map(({ file, url }, index) => (
                          <div key={index} className="w-full border border-secondary-100 rounded-md p-4 flex items-center gap-4">
                            {file.type.startsWith("image/") ? (
                              <img
                                src={url}
                                alt="Proof of Insurance preview"
                                className="h-24 w-40 object-cover rounded-md flex-shrink-0"
                              />
                            ) : file.type.startsWith("video/") ? (
                              <video
                                src={url}
                                className="h-24 w-40 object-cover rounded-md flex-shrink-0 bg-black"
                                controls
                                preload="metadata"
                                playsInline
                              />
                            ) : (
                              <div className="h-24 w-40 flex items-center justify-center bg-gray-100 rounded-md flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24">
                                  <path fill="#9AA3AD" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM6 20V4h5v7h7v9H6z" />
                                </svg>
                              </div>
                            )}
                            <div className="flex-1 min-w-0">
                              <p className="text-sm font-medium text-text-color truncate">{file.name}</p>
                              <p className="text-xs text-gray-400 mt-1">{file.size >= 1024 * 1024 ? `${(file.size / (1024 * 1024)).toFixed(2)} MB` : `${(file.size / 1024).toFixed(1)} KB`}</p>
                              <div className="flex gap-3 mt-2">
                                <a
                                  href={url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-xs text-primary-brand font-semibold hover:underline"
                                >
                                  {file.type.startsWith("image/") ? "Preview" : file.type.startsWith("video/") ? "Play" : "Open"}
                                </a>
                                <button
                                  type="button"
                                  onClick={() => {
                                    URL.revokeObjectURL(url);
                                    setProofOfInsuranceFiles(prev => prev.filter((_, i) => i !== index));
                                    if (fileInputRef.current) fileInputRef.current.value = "";
                                  }}
                                  className="text-xs text-red-500 font-semibold hover:underline"
                                >
                                  Delete
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    <input
                      ref={fileInputRef}
                      type="file"
                      style={{ display: "none" }}
                      accept="image/*,application/pdf"
                      multiple
                      onChange={(e) => {
                        const files = e.target.files ? Array.from(e.target.files) : [];
                        // Proof of insurance is a document — reject video (and any
                        // other unsupported type) and tell the renter why (1NOW-1232).
                        const allowed = files.filter(
                          (f) => f.type.startsWith("image/") || f.type === "application/pdf"
                        );
                        if (allowed.length < files.length) {
                          toast.error("Videos aren't supported. Please upload an image or PDF.");
                        }
                        if (allowed.length > 0) {
                          setProofOfInsuranceFiles(prev => [
                            ...prev,
                            ...allowed.map(f => ({ file: f, url: URL.createObjectURL(f) }))
                          ]);
                        }
                        e.target.value = "";
                      }}
                    />
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => fileInputRef.current?.click()}
                      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") fileInputRef.current?.click(); }}
                      className="flex flex-col items-center justify-center w-full border-2 border-dashed border-secondary-100 rounded-md p-6 cursor-pointer hover:border-primary-brand transition-colors"
                    >
                      <svg
                        width="44"
                        height="44"
                        viewBox="0 0 44 44"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect x="2" y="2" width="40" height="40" rx="8" stroke="#9AA3AD" strokeWidth="2" />
                        <path d="M22 30V14M22 14L16 20M22 14L28 20" stroke="#9AA3AD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span className="mt-2 text-sm text-text-color">Proof Of Insurance</span>
                    </div>
                  </div>
                )}
            </div>
          ))}
      </div>
    );
  };

  // 1NOW-10770: the code question for "Pay and book now": the Pay step shows it (steps), or a dialog over the page.
  const codeQuestion: CodeGate | null = codeGate && {
    ...codeGate,
    onVerify: async (code) => {
      const r = await verifyEmailCode(codeGate.customer, code);
      if ("error" in r) return { error: r.error, bad: true };
      setRenterSession(r.data);
      verifiedRenter.current = { key: JSON.stringify(codeGate.customer), data: r.data };
      // The booking, from what is on the page, with the renter the code has just proved.
      const made = await handleBooking();
      if (!made) {
        setCodeGate(null);
        if (phoneOpenRef.current) steps.toReviewAfterCode();
      }
      return { ok: true };
    },
    onDifferentEmail: () => differentEmail(),
  };

  /** "Use a different email" (1NOW-10770): no code, the email emptied and focused where it is typed; name and phone stay. */
  const differentEmail = () => {
    verifiedRenter.current = null;
    setCodeGate(null);
    setEmail("");
    steps.onDifferentEmail();
    // The page without steps: its own form, once the dialog has handed the focus back.
    window.setTimeout(() => emailInput.current?.focus(), 60);
  };
  // The Reserved page's "Use a different email" comes back here: to the details, once the car is on the page.
  const differentEmailArrival = useRef((location.state as any)?.differentEmail === true);
  useEffect(() => {
    if (!differentEmailArrival.current || !selectedCar) return;
    differentEmailArrival.current = false;
    differentEmail();
  }, [selectedCar]);

  const steps = usePhoneBooking({
    isPhone,
    isDesktop,
    longTermView: Boolean(
      ourCompany?.allow_long_term_rentals &&
        startDate &&
        endDate &&
        long_term_rental_nature !== "daily" &&
        long_term_rental_duration > 1,
    ),
    open: phoneOpen,
    setOpen: setPhoneOpen,
    step: phoneStep,
    setStep: setPhoneStep,
    madeBooking,
    setMadeBooking,
    car: selectedCar,
    ourCompany,
    companyDetails,
    invoice,
    bookingdetails,
    pickupLocation,
    dropOffLocation,
    sameDropoffLocation,
    dropoffLocationType,
    startDate,
    endDate,
    startTime,
    endTime,
    products: is_hourly_rental ? [] : (bonzahProducts?.insurance_options ?? []),
    productsLoading: bonzahProductsLoading,
    selectedBonzahType,
    bonzahProducts,
    onSelectProduct: attemptBonzahProductSelection,
    proofFiles: proofOfInsuranceFiles,
    setProofFiles: setProofOfInsuranceFiles,
    proofInputRef: fileInputRef,
    addons: !bonzahProductsLoading && !is_hourly_rental ? (bonzahProducts?.addons ?? []) : [],
    selectedExtras,
    onExtra: handleExtraChange,
    selectedAddons: selectedBonzahAddOns,
    onAddon: attemptAddonSelection,
    firstName,
    lastName,
    email,
    phone,
    setFirstName,
    setLastName,
    setEmail,
    setPhone,
    errors,
    clearError,
    validateForm,
    renterDetailsConfirmed,
    setRenterDetailsConfirmed,
    handleBooking: () => handleBooking(),
    handleBookingLater: () => handleBookingLater(),
    loading,
    loadingLater,
    codeGate: codeQuestion,
  });
  const { phoneSteps, desktopSteps } = steps;
  phoneOpenRef.current = steps.props.open;
  // The steps replace what the old desktop page drew: the renter form, the protection and extras sections and the bill.
  const stepped = phoneSteps || desktopSteps;

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const carIdParam = searchParams.get("selectedCarId");

    // A car chosen on the way in stays: the provider names it in the address (1NOW-11383).
    if (!carIdParam && !selectedCar) {
      navigate("/");
    }
  }, []);

  const carIdParam =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search).get("selectedCarId")
      : null;

  if (carIdParam && !selectedCar) {
    // `ourVehicles` is empty both before the fleet request starts and after it
    // fails, so gating on its length alone kept this spinner turning forever
    // whenever the load didn't succeed — the infinite spin in 1NOW-1664. The
    // settled flag is what actually separates "still waiting" from "we have our
    // answer, and it was nothing".
    const stillLoading = ourVehiclesLoading || !ourVehiclesSettled;
    const carExists = ourVehicles.some((v) => String(v.id) === carIdParam);

    // A load that failed is not a car that doesn't exist: sending the renter to
    // /404 would blame them for our network. Say what happened and let them
    // retry without losing the page.
    if (!stillLoading && ourVehiclesError) {
      return (
        <div className="ListingCarDetailPage container">
          <div className="flex justify-between items-center my-4">
            {isB ? <BackToCars className="text-text-color" /> : <BackRouteButton iconVariant="square" />}
          </div>
          <div className="flex flex-col justify-center items-center min-h-[50vh] gap-4 text-center">
            <p className="text-neutral-600 dark:text-neutral-300 max-w-md">
              {ourVehiclesError}
            </p>
            <ButtonPrimary onClick={retryOurVehicles}>Try again</ButtonPrimary>
          </div>
        </div>
      );
    }

    if (stillLoading || carExists) {
      return (
        <div className="ListingCarDetailPage container">
          <div className="flex justify-between items-center my-4">
            {isB ? <BackToCars className="text-text-color" /> : <BackRouteButton iconVariant="square" />}
          </div>
          <div className="flex flex-col justify-center items-center min-h-[50vh] gap-4">
            <div className="w-10 h-10 rounded-full border-4 border-neutral-200 border-t-primary-6000 animate-spin" />
          </div>
        </div>
      );
    }

    return <Navigate to="/404" replace />;
  }

  // 1NOW-11176: Design B's trip fields, and the bar that carries them once they have scrolled away. A renter
  // who is booking weekly, monthly or hourly keeps the bar away: its calendar is the daily one.
  const canChooseDropoff = ourLocation.some(
    (loc) => loc.location_type === "drop_off" || loc.location_type === "both",
  );
  const hasOwnDatesField = Boolean(ourCompany?.allow_long_term_rentals || ourCompany?.allow_hourly_rentals);
  const tripCard = isB ? (
    <CarTripCard
      ourLocation={ourLocation}
      selectedCar={selectedCar}
      isDropOffVisible={isDropOffVisible}
      canChooseDropoff={canChooseDropoff}
      onDifferentDropoff={handleDropOffLocationClick}
      onSameDropoff={handlePickupLocationClick}
      timeEffects={Boolean((startDate && endDate) || phoneSteps)}
      datesField={
        hasOwnDatesField ? (
          <DateRangeSelection
            look="b"
            isMiddle={true}
            selectedCar={selectedCar}
            onSaveDates={fetchInvoice}
          />
        ) : undefined
      }
    />
  ) : null;
  const tripBarOn = isB && long_term_rental_nature === "daily" && !is_hourly_rental;

  return (
    <>
      {/* Hidden, not unmounted, behind the desktop steps: the trip fields keep what was picked. */}
      <div className={`ListingCarDetailPage container${phoneSteps ? " pb-28" : ""}${desktopSteps && steps.props.open ? " hidden" : ""}`}>
        {isB && <CarTopB car={selectedCar} />}
        {!isB && (<>
        <div className="flex justify-between items-center gap-4 my-4">
          {isB ? <BackToCars className="text-text-color" /> : <BackRouteButton iconVariant="square" />}
          <span className="text-xl font-semibold truncate block text-text-color">
            {selectedCar?.name}
          </span>
        </div>
        <header className="rounded-md sm:rounded-xl">
          {/* Phones show only the default (first) photo; the rest open from "Show all photos". */}
          <div className="relative grid grid-cols-1 md:grid-cols-4  gap-1 sm:gap-2 min-h-64 md:min-h-96 ">
            <div
              className="col-span-2 row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer"
              onClick={() => {
                handleOpenModalImageGallery(0);
                setCurrentIndex(0);
              }}
            >
              <img
                src={
                  (selectedCar?.fleet_photos?.length ?? 0) > 0
                    ? selectedCar?.fleet_photos[0].photo_url?.includes("http")
                      ? selectedCar?.fleet_photos[0].photo_url
                      : `https://fleet-management-images-upload-be.s3.amazonaws.com/${selectedCar?.fleet_photos[0].photo_url}`
                    : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                }
                alt="0"
                className="absolute inset-0 object-cover rounded-md sm:rounded-md w-full h-full"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
              />
              <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
            </div>

            {/*  */}
            <div
              className="hidden md:block col-span-1 row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer"
              onClick={() => {
                handleOpenModalImageGallery(1);
                setCurrentIndex(1);
              }}
            >
              <img
                className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
                src={
                  (selectedCar?.fleet_photos?.length ?? 0) > 1
                    ? selectedCar?.fleet_photos[1].photo_url?.includes("http")
                      ? selectedCar?.fleet_photos[1].photo_url
                      : `https://fleet-management-images-upload-be.s3.amazonaws.com/${selectedCar?.fleet_photos[1].photo_url}`
                    : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                }
                alt="1"
                sizes="400px"
              />
              <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
            </div>

            {/*  */}
            {selectedCar?.fleet_photos
              .filter((_: any, i: any) => i >= 2 && i < 4)
              .map((item: any, index: any) => (
                <div
                  key={index}
                  className="hidden md:block relative rounded-md sm:rounded-xl overflow-hidden"
                >
                  <div className="aspect-w-4 aspect-h-3">
                    <img
                      className="absolute inset-0 object-cover w-full h-full rounded-md sm:rounded-xl "
                      src={
                        item.photo_url?.includes("http")
                          ? item.photo_url
                          : `https://fleet-management-images-upload-be.s3.amazonaws.com/${item.photo_url}`
                      }
                      alt="photos"
                      sizes="400px"
                    />
                  </div>
                  <div
                    className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                    onClick={() => {
                      handleOpenModalImageGallery(2);
                      setCurrentIndex(2);
                    }}
                  />
                </div>
              ))}

            {((selectedCar?.fleet_photos?.length ?? 0) > 1) && (
              <div
                className="absolute flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 cursor-pointer hover:bg-neutral-200 z-10"
                onClick={() => setIsGridOpen(true)}
              >
                <Squares2X2Icon className="h-5 w-5" />
                <span className="ml-2 text-neutral-800 text-sm font-medium">
                  Show all photos
                </span>
              </div>
            )}
          </div>
        </header>
        </>)}

        {isGridOpen && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center p-4">
            <div className="relative w-full max-w-5xl bg-white rounded-lg overflow-auto p-4">
              <button
                className="absolute top-1 right-3 text-lg text-text-color bg-white rounded-full w-10 h-10 flex items-center justify-center z-10"
                onClick={closeGridModal}
                aria-label="Close gallery"
                type="button"
              >
                ✖
              </button>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 pt-8">
                {(selectedCar?.fleet_photos ?? []).map(
                  (item: any, idx: number) => (
                    <button
                      key={idx}
                      onClick={() => {
                        setCurrentIndex(idx);
                        setIsOpenModal(true);
                        setIsGridOpen(false);
                      }}
                      className="w-full h-32 sm:h-40 md:h-48 overflow-hidden rounded-md focus:outline-none focus:ring-2 focus:ring-primary-brand transition-transform hover:scale-105"
                      type="button"
                    >
                      <img
                        src={
                          item.photo_url?.includes("http")
                            ? item.photo_url
                            : `https://fleet-management-images-upload-be.s3.amazonaws.com/${item.photo_url}`
                        }
                        alt={`photo-${idx}`}
                        className="w-full h-full object-cover"
                      />
                    </button>
                  ),
                )}
                {(selectedCar?.fleet_photos?.length ?? 0) === 0 && (
                  <div className="col-span-full text-center p-8 text-text-color">
                    No images available
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {isOpenModal && (
          <div className="fixed h-full top-0 left-0 w-full bg-bg-color  flex items-center justify-center z-50">
            <button
              className="absolute top-5 right-5 text-text-color text-xl"
              onClick={closeModal}
            >
              ✖
            </button>

            <div className="w-4/5 ">
              <Slide
                defaultIndex={currentIndex}
                indicators={(selectedCar?.fleet_photos?.length ?? 0) > 1}
                arrows={(selectedCar?.fleet_photos?.length ?? 0) > 1}
                autoplay={false}
                duration={2000}
                transitionDuration={300}
                onChange={(current, next) => {
                  setCurrentIndex(next);
                }}
                prevArrow={
                  <button
                    className={`absolute left-4 top-1/2 -translate-y-1/2 z-10 flex items-center justify-center w-10 h-10 rounded-full bg-transparent text-text-color ${(selectedCar?.fleet_photos?.length ?? 0) <= 1 ||
                      currentIndex === 0
                      ? "invisible"
                      : ""
                      }`}
                    type="button"
                    aria-label="Previous"
                  >
                    <span className="default-nav !text-text-color">❮</span>
                  </button>
                }
                nextArrow={
                  <button
                    className={`absolute right-4 top-1/2 -translate-y-1/2 z-10 flex items-center justify-center w-10 h-10 rounded-full bg-transparent text-text-color ${(selectedCar?.fleet_photos?.length ?? 0) <= 1 ||
                      currentIndex ===
                      (selectedCar?.fleet_photos?.length ?? 0) - 1
                      ? "invisible"
                      : ""
                      }`}
                    type="button"
                    aria-label="Next"
                  >
                    <span className="default-nav !text-text-color">❯</span>
                  </button>
                }
              >
                {((selectedCar?.fleet_photos?.length ?? 0) || 0) > 0 ? (
                  selectedCar?.fleet_photos?.map((item: any, index: number) => (
                    <div
                      className="flex justify-center items-center h-full"
                      key={index}
                    >
                      <img
                        className="w-full max-h-full object-contain rounded-lg"
                        src={
                          item.photo_url?.includes("http")
                            ? item.photo_url
                            : `https://fleet-management-images-upload-be.s3.amazonaws.com/${item.photo_url}`
                        }
                        alt={`Slide ${index}`}
                      />
                    </div>
                  ))
                ) : (
                  <div className="flex justify-center items-center h-full">
                    <img
                      className="w-full max-h-full object-contain rounded-lg"
                      src="https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                      alt="No images available"
                    />
                  </div>
                )}
              </Slide>
            </div>
          </div>
        )}

        <main className=" relative z-10 mt-11 flex flex-col lg:flex-row ">
          <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:pr-10 lg:space-y-10">
            {/* {vehicleFeaturesSection()} */}
            {isB && tripCard}
            {/* 1NOW-11219: Design B's car details are in the fleet card's panel and the header's Car details. */}
            {!isB && <VehicleDetailsSection data={selectedCar} />}
            {renderUserSection()}
            {!stepped &&
              bonzahProducts?.insurance_options?.length > 0 &&
              renderBonzahSection()}
            {!stepped &&
              (bonzahProducts?.addons?.length > 0 ||
              (selectedCar?.extras ?? []).length > 0) &&
              renderExtrasSection()}
          </div>

          <div className="block mb-6 lg:mb-0 flex-grow mt-0 lg:mt-0">
            <div className="block sticky top-28 space-y-4">
              {!stepped && renderSidebarPrice()}
              {desktopSteps && <CarPageOverview {...steps.props} />}
            </div>
          </div>
        </main>
      </div>
      <BonzahAcknowledgement
        isOpen={bonzahAckOpen}
        onClose={() => {
          setBonzahAckOpen(false);
          setPendingBonzahProduct(null);
          setPendingBonzahAddon(null);
          // If the renter declines the terms from the booking-time popup,
          // abandon the booking attempt — they shouldn't be auto-submitted
          // without explicit acceptance (ONENOW-491).
          setPendingBookingMode(null);
        }}
        onConfirm={confirmBonzahAcknowledgement}
      />
      {tripBarOn && (
        <CarTripBar
          suppressed={steps.props.open}
          carName={selectedCar?.name}
          selectedCar={selectedCar}
          ourLocation={ourLocation}
          onUpdate={fetchInvoice}
          isDropOffVisible={isDropOffVisible}
          canChooseDropoff={canChooseDropoff}
          onDifferentDropoff={handleDropOffLocationClick}
          onSameDropoff={handlePickupLocationClick}
        />
      )}
      {codeQuestion && !stepped && <EmailCodeDialog gate={codeQuestion} onClose={() => setCodeGate(null)} />}
      {phoneSteps && <PhoneBooking {...steps.props} />}
      {desktopSteps && <DesktopBooking {...steps.props} />}
    </>
  );
}
